import VideoComponent from "src/components/ui/VideoComponent"
import { DashboardLayout } from "../Dashboard/DashboardLayout"


const TutorialView = () => {

  const slotGuideEnglishURL = "https://drive.google.com/file/d/1O_3op1oOkL-S-VY_ooV2oFf2_3iVNAn7/view?usp=sharing";

  const examGuideEnglishURL= "https://drive.google.com/file/d/14vkmSriNNHQwT1FPAeiHOvPEfMVnJWB_/view?usp=sharing";

  function getEmbedLink(driveLink: string) {

  const fileIdMatch = driveLink.match(/(?:\/d\/|id=|\/uc\?id=)([a-zA-Z0-9_-]+)/);
  
  if (fileIdMatch && fileIdMatch[1]) {
    const fileId = fileIdMatch[1];

    return `https://drive.google.com/file/d/${fileId}/preview`;
  } else {
      console.error("Invalid Google Drive link.");
      return null;
    }
  }

  const examGuideEnglish = getEmbedLink(examGuideEnglishURL);
  const slotGuideEnglish = getEmbedLink(slotGuideEnglishURL);

  return (
    <DashboardLayout>
      <div className="w-full h-fit xl:overflow-auto xl:h-full flex flex-col justify-center xl:block">
        <div className="mx-auto my-6 flex flex-col justify-center items-center border-b border-slate-400 pb-5">
          <h1 className="text-primary text-lg xl:text-xl my-6 text-center font-semibold">Comprehensive Video Guide: How to Book the Exam Slot</h1>
          <VideoComponent src={slotGuideEnglish!}/> 
        </div>
        
         {/* <div className=" mx-auto my-6 flex flex-col justify-center items-center border-b border-slate-400 pb-5">
          <h1 className="text-primary text-lg xl:text-xl my-6 text-center font-semibold">Comprehensive Video Guide: How to Book the Exam Slot (Hindi)</h1>
          <VideoComponent src = {SLOTHINDI!}/> 
         </div> */}
        <div className="mx-auto my-6 flex flex-col justify-center items-center border-b border-slate-400 pb-5">
          <h1 className="text-primary text-lg xl:text-xl my-6 text-center font-semibold">Comprehensive Video Guide: How to Successfully Take the Exam</h1>
          <VideoComponent src={examGuideEnglish!}/> 
        </div>
        
         {/* <div className=" mx-auto my-6 flex flex-col justify-center items-center border-b border-slate-400 pb-5">
          <h1 className="text-primary text-lg xl:text-xl my-6 text-center font-semibold">Comprehensive Video Guide: How to Successfully Take the Exam (Hindi)</h1>
          <VideoComponent src = {HINDI!}/> 
         </div> */}
      </div>
    </DashboardLayout>
  )
}

export default TutorialView